import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const NavigationBar = () => {
  const location = useLocation();
  
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">NextLog</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              active={location.pathname === '/'}
            >
              Home
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/case-attribution" 
              active={location.pathname === '/case-attribution'}
            >
              Case Attribution
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/message-classification"
              active={location.pathname === '/message-classification'}
            >
              Message Classification
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/message-summarization"
              active={location.pathname === '/message-summarization'}
            >
              Message Summarization
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/process-visualization"
              active={location.pathname === '/process-visualization'}
            >
              Process Visualization
           </Nav.Link>
           <Nav.Link
             as={Link}
             to="/process-guessing"
             active={location.pathname === '/process-guessing'}
           >
             Process Guessing
           </Nav.Link>
           <Nav.Link
             as={Link}
             to="/case-history"
             active={location.pathname === '/case-history'}
           >
             Case History
           </Nav.Link>
           <Nav.Link
             as={Link}
             to="/prompt-history"
             active={location.pathname === '/prompt-history'}
           >
             Prompt History
           </Nav.Link>
         </Nav>
          <Nav className="ms-auto">
            <Nav.Link 
              onClick={() => window.open('/docs/NextLog Demo User Guide.pdf', '_blank')} 
              style={{ border: '1px solid rgba(255,255,255,0.3)', borderRadius: '4px', padding: '0.5rem 1rem', cursor: 'pointer' }}
            >
              ❓ Help
            </Nav.Link>
          </Nav>
       </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;